import React from "react";
import { Space, Table, Tag } from "antd";
import SearchInput from "../../../components/utils/SearchInput";
import { deleteDeliveryFee } from "../../../actions/delivery.action";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import TableColumnLoader from "../../../components/loader/TableColumnLoader";


const AntTable = ({ list, handleSearch, handleCreate, handleEdit, deleteStatusState }) => {
  const dispatch = useDispatch();
  const columns = [
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "GIG Amount",
      dataIndex: "gigAmount",
      key: "gigAmount",
    },
    {
      title: "Compass Amount",
      dataIndex: "compassAmount",
      key: "compassAmount",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Tag
            color={"blue"}
            className="cursor-pointer"
            onClick={() => handleEdit(record)}
          >
            Edit
          </Tag>

          {deleteStatusState[record.id] ? (
            <TableColumnLoader />
          ) : (
          <Tag
            color={"red"}
            className="cursor-pointer"
            onClick={() =>
              dispatch(deleteDeliveryFee(record.id))
            }
          >
            Delete
          </Tag>)}
        </Space>
      ),
    },
  ];
  return (
    <div>
      <div className="flex justify-between items-center py-4 bg-white dark:bg-gray-800">
        <div>
          <button
            className="bg-green-800 text-white rounded-md p-2 px-4"
            onClick={() => handleCreate()}
          >
            add
          </button>
        </div>
        <SearchInput handleSearch={(value) => handleSearch(value)} />
      </div>
      <Table
        columns={columns}
        pagination={{}}
        dataSource={list}
        scroll={{
          x: 500,
        }}
        sticky
      />
    </div>
  );
};

export default AntTable;
